module.exports = __webpack_public_path__ + "assets/infographic-icon-1.41edd437.svg";